module.exports = __webpack_public_path__ + "static/media/img_compare.e9219f4f.jpg";